import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useParams } from "react-router-dom";
import { FirebaseFuntions } from "../../context/FirebaseContext";
import SuspendedProject from "../../pages/SuspendedProject/SuspendedProject";
import logo from "../../assets/makinn/makinn.png";

const ProjectStatusGuard = ({ children }) => {
  const { projectId } = useParams();
  const { projectPhoto } = useContext(FirebaseFuntions);
  const [isLoading, setIsLoading] = useState(Boolean(projectId));
  const [isSuspended, setIsSuspended] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (!projectId) {
      setIsLoading(false);
      setIsSuspended(false);
      return undefined;
    }

    const loadProject = async () => {
      try {
        const projectData = await projectPhoto(projectId);

        if (!isMounted) {
          return;
        }

        setIsSuspended(Number(projectData?.status) === 0);
      } catch (error) {
        console.log(error);
        if (isMounted) {
          setIsSuspended(false);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadProject();

    return () => {
      isMounted = false;
    };
  }, [projectId, projectPhoto]);

  if (isLoading) {
    return (
      <AnimatePresence>
        <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
          <motion.img
            initial={{ rotateY: 0 }}
            animate={{ rotateY: 360 }}
            transition={{
              duration: 2,
              repeat: Infinity,
              type: "tween",
              repeatDelay: 0,
            }}
            exit={{ opacity: 0 }}
            src={logo}
            alt="logo makinn"
            className="mx-auto mb-5"
            width={150}
            height={150}
          />
          <p className="uppercase text-lg">Cargando</p>
        </div>
      </AnimatePresence>
    );
  }

  if (isSuspended) {
    return <SuspendedProject />;
  }

  return children;
};

export default ProjectStatusGuard;
